




































import { Component, Vue, Prop } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
@Component({})
export default class Login extends Vue {
  private curTab: any = {};
  private get href() {
    return window.location.href;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private changeOpen(item: any) {
    item.open = !item.open;
  }
  private goRouter(item: any) {
    if (!item.path) {
      return;
    }
    this.curTab = item;
    this.$store.commit("updatePatient", null);
    clearFilter();
    this.$router.push(item.path);
  }
  private mounted() {}
}
